export default __webpack_public_path__ + "static/media/PPMone Logo Grey and Blue.dec9bf5e.png";